var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetupToolLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 292,
    viewBox: "0 0 292 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.059 292H154.941C159.39 292 163 288.354 163 283.861V217.139C163 212.646 159.39 209 154.941 209H137.059C132.61 209 129 212.646 129 217.139V283.861C129 288.354 132.61 292 137.059 292Z",
    fill: "#E5B265"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.059 83H154.941C159.39 83 163 79.3582 163 74.8694V8.13061C163 3.64184 159.39 0 154.941 0H137.059C132.61 0 129 3.64184 129 8.13061V74.7847C129 79.3582 132.61 83 137.059 83Z",
    fill: "#E5B265"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13891 163H74.8611C79.3544 163 83 159.39 83 154.941V137.059C83 132.61 79.3544 129 74.8611 129H8.13891C3.64555 129 0 132.61 0 137.059V154.941C0 159.39 3.64555 163 8.13891 163Z",
    fill: "#E5B265"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M209 137.059V154.941C209 159.39 212.646 163 217.139 163H283.861C288.354 163 292 159.39 292 154.941V137.059C292 132.61 288.354 129 283.861 129H217.139C212.646 129 209 132.61 209 137.059Z",
    fill: "#E5B265"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3427 242.859L49.0902 255.596C52.2982 258.801 57.4478 258.801 60.5714 255.596L107.594 208.613C110.802 205.407 110.802 200.262 107.594 197.141L94.8465 184.404C91.6385 181.199 86.4889 181.199 83.365 184.404L36.3427 231.387C33.2191 234.508 33.2191 239.654 36.3427 242.859Z",
    fill: "#E5B265"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.141 107.596C200.346 110.801 205.492 110.801 208.613 107.596L255.596 60.6126C258.801 57.4073 258.801 52.2619 255.596 49.1409L242.859 36.404C239.654 33.1987 234.508 33.1987 231.387 36.404L184.404 83.3873C181.199 86.5927 181.199 91.7381 184.404 94.8591L197.141 107.596Z",
    fill: "#E5B265"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.87 184.226L184.226 196.87C181.079 200.016 181.105 205.146 184.282 208.324L231.462 255.503C234.639 258.681 239.769 258.706 242.916 255.56L255.56 242.915C258.706 239.769 258.681 234.639 255.503 231.462L208.324 184.282C205.146 181.105 200.016 181.079 196.87 184.226Z",
    fill: "#262626"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.343 160.699L160.699 173.343C157.553 176.489 156.442 180.483 158.219 182.26L184.606 208.647C186.383 210.424 190.377 209.314 193.523 206.167L206.167 193.523C209.314 190.377 210.424 186.383 208.647 184.606L182.26 158.219C180.483 156.442 176.489 157.553 173.343 160.699Z",
    fill: "#262626"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.918 160.658C190.677 145.85 187.478 128.467 175.319 116.234C162.52 103.357 143.321 100.782 127.962 107.864L155.48 135.549L136.282 154.864L108.124 127.179C100.444 142.631 103.644 161.946 116.443 174.822C128.602 187.055 145.881 190.274 160.6 184.48C163.799 181.905 184.918 160.658 184.918 160.658Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupToolLogo);
export default __webpack_public_path__ + "static/media/setup-tool-logo.6da7ee332d120923c7f132d943e4a65f.svg";
export { ForwardRef as ReactComponent };